module.exports = __webpack_public_path__ + "static/media/userActive.7b37c105.svg";